function basketHeight() {
    if ($('basket').length > 0) {
        var basketHeight = $('basket').outerHeight();
        $('.tickets_page').css({'padding-bottom': basketHeight + 'px'});
    }
}

function toTimestamp(ddmmyy) {
    var ddmmyy  = ddmmyy.split('/'),
        dd      = ddmmyy[0],
        mm      = ddmmyy[1],
        yy      = ddmmyy[2],
        jsDate  = yy + '-' + mm + '-' + dd;
    var datum = Date.parse(jsDate);
    return (datum/1000);
}

// Javascript translations
var translations = [];
// Set values
translations['fr'] = [];
translations['nl'] = [];
translations['en'] = [];
translations['de'] = [];
// Set translations
translations['fr']['countdown'] = [];
translations['fr']['countdown']['noty_redirect']    = 'Votre panier vient d\'expirer. Vous allez être redirigé vers la page d\'accueil.';
translations['fr']['countdown']['noty_increase']    = '<p>Souhaitez-vous prolonger la durée de votre panier de 10 minutes ? Cette action n\'est faisable qu\'une fois.</p>';
translations['fr']['countdown']['noty_no']          = 'Non';
translations['fr']['countdown']['noty_yes']         = 'Prolonger';
translations['nl']['countdown'] = [];
translations['nl']['countdown']['noty_redirect']    = 'Je winkelmand is net verlopen. Je wordt doorgestuurd naar onze startpagina.';
translations['nl']['countdown']['noty_increase']    = '<p>Wilt u de duur van uw mandje met 10 minuten verlengen? Deze actie kan slechts eenmaal worden ondernomen.</p>';
translations['nl']['countdown']['noty_no']          = 'Nee';
translations['nl']['countdown']['noty_yes']         = 'Verlengen';
translations['en']['countdown'] = [];
translations['en']['countdown']['noty_redirect']    = 'Your basket has expired. You will be redirected to our homepage.';
translations['en']['countdown']['noty_increase']    = '<p>Would you like to extend the duration of your basket by 10 minutes? This action can only be taken once.</p>';
translations['en']['countdown']['noty_no']          = 'No';
translations['en']['countdown']['noty_yes']         = 'Extend';
translations['de']['countdown'] = [];
translations['de']['countdown']['noty_redirect']    = 'Ihr Warenkorb ist gerade abgelaufen. Sie werden auf die Startseite weitergeleitet.';
translations['de']['countdown']['noty_increase']    = '<p>Möchten Sie die Dauer Ihres Warenkorbs um 10 Minuten verlängern? Diese Aktion ist nur einmal durchführbar.</p>';
translations['de']['countdown']['noty_no']          = 'Nichet';
translations['de']['countdown']['noty_yes']         = 'Verlängern';


$(document).ready(function(e) {

    // VARIABLES
    //----------------------------------//
    var baseHref    = $('base').attr('href'),
        slang       = $('html').attr('lang'),
        ajaxLang    = slang;

    // GENERIC
    //----------------------------------//

    // Select2js dropdown
    $('.select2').select2();
    $('.select2small').select2();
    $('.select2small').parent().find('.select2').addClass('select2small');

    pictogramModal();

    function increaseCountdown() {

        var n = new Noty({
            type: 'confirm',
            layout: 'center',
            theme: 'nest',
            text: translations[ajaxLang].countdown.noty_increase,
            buttons: [
                Noty.button(translations[ajaxLang].countdown.noty_no, 'btn btn-success btn-noty-left', function () {
                    n.close();
                }),
                Noty.button(translations[ajaxLang].countdown.noty_yes, 'btn btn-success btn-noty-right', function () {
                    // Close modal
                    n.close();
                    // Update countdown
                    $.ajax({
                        type: 'POST',
                        url: ajaxLang + '/ajax',
                        data: {
                            function: 'increaseCountdown'
                        },
                        dataType: "json",
                        cache: false,
                    }).done(function (response) {

                        if(response.status=='success') {
                            // Update timestamp
                            $('.countdown').data('timestamp', response.countdown.timestamp);
                            $('.countdown').html(response.countdown.value);
                        }

                        // Show pictograms in modal
                        var n = new Noty({
                            type: 'confirm',
                            layout: 'center',
                            theme: 'nest',
                            text: response.noty_message,
                            buttons: [
                                Noty.button(response.noty_button, 'btn btn-error btn-noty-left', function () {
                                    n.close();
                                })
                            ]
                        });
                        n.show();

                    });
                })
            ]
        });
        n.show();

    }

    // Countdown
    function initCountdown() {

        if($('.countdown').length > 0) {

            var interval = setInterval(function() {

                // variables
                var countdown   = $('.countdown').html(),
                    timestamp   = Number($('.countdown').data('timestamp')),
                    currentTs   = Math.round($.now()/1000),
                    diff        = Number(timestamp - currentTs + (20*60));

                // Prepare minutes:seconds rendering
                var minutes = Math.floor(diff / 60),
                    seconds = diff - minutes * 60,
                    verification = 5; // 5 minutes show alert

                if(minutes<verification) {
                    // Remove default pictogram
                    $('.timerPicto').removeClass('pictogramModal');
                    // Show warning and possibility to increase countdown
                    $('.timer').addClass('danger increaseCountdown');
                } else if(minutes>=verification) {
                    // Add default pictogram (timer)
                    $('.timerPicto').addClass('pictogramModal');
                    // Hide warning and possibility to increase countdown
                    $('.timer').removeClass('danger increaseCountdown');
                }

                function str_pad_left(string,pad,length) {
                    return (new Array(length+1).join(pad)+string).slice(-length);
                }

                var finalTime = str_pad_left(minutes,'0',2)+':'+str_pad_left(seconds,'0',2);

                if(seconds<=60 && minutes<0) {

                    var alerted = localStorage.getItem('alerted') || '';

                    if(alerted!='yes') {

                        localStorage.setItem('alerted','yes');

                        // Show alert then redirect to new page after 5 seconds
                        var n = new Noty({
                            type: 'confirm',
                            layout: 'center',
                            theme: 'nest',
                            timeout: 2500,
                            text: translations[ajaxLang].countdown.noty_redirect
                        });
                        n.show();

                        setTimeout(function(){
                            localStorage.setItem('alerted','');
                            window.location.href = baseHref + ajaxLang + '?session=new';
                        }, 2500);

                    }

                }

                $('.countdown').html(finalTime);

            }, 1000);

        }

    }

    initCountdown();

    $(document).on('click', '.increaseCountdown', function() {

        increaseCountdown();

    })

    // MAIN Functions
    //----------------------------------//

    // Add Product to Basket
    /*function addProductToBasket() {

        // update product quantity in basket
        $('.updateBasket').click(function(e) {

            // parameters
            var familyCode      = $(this).data('familycode'),
                productCode     = $(this).data('productcode'),
                action          = $(this).data('action'),
                section         = $(this).data('section'),
                mappingId       = $(this).data('mappingid'),
                quantity        = $('#quantity'+productCode).val();

            // ajax query
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    familyCode: familyCode,
                    productCode: productCode,
                    action: action,
                    section: section,
                    mappingId: mappingId,
                    function: 'updateProductToBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    $('input[name^="quantity"]').val(0);
                    var total = 0;
                    $.each(response.update, function(pc,q) {
                        $('input[name="quantity['+pc+']"]').attr('value',q).val(q);
                        total++;
                    })

                    // minus add opacity
                    if(quantity<=1 && action=='substract') {
                        $('#minusIcon_'+productCode).css('opacity','0.5');
                    } else {
                        $('#minusIcon_'+productCode).css('opacity','1');
                    }

                    if(total==0) {
                        // Addclass DISABLED if input value = 0
                        $('basket').addClass('hide');
                        $('#basketProductsList').html('');
                    } else {
                        $('basket').removeClass('hide');
                        $('#basketProductsList').html(response.footerBasket);
                        $('#basketProductsTotal,#basketHeaderTotal').html(response.total);
                    }
                } else {
                    alert('Error');
                }
            });

        });

    }*/


    // Add Product to Basket
    /*function addAnimationToBasket() {

        // update product quantity in basket
        $('.addEventToBasket').click(function(e) {

            $(this).prop('disabled',true);

            var date            = $('input[name="date"]:checked').val(),
                eventId         = $('input[name="hour"]:checked').val(),
                hour            = $('input[name="hour"]:checked').data('hour'),
                section         = $(this).data('section'),
                mappingId       = $(this).data('mappingid'),
                checkoutUrl     = $(this).data('checkout');

            // process products and save in events array
            var events = {};
            $('input[name^="quantity"]').each(function(index) {

                var familyCode      = $(this)[0].dataset.familycode,
                    productCode     = $(this)[0].dataset.productcode,
                    quantity        = $(this)[0].value;
                if(quantity>0) {
                    // create array if not exists
                    if(events[familyCode]==undefined) { events[familyCode] = {}; }
                    // create array if not exists
                    events[familyCode][productCode] = quantity;
                }
            })

            // ajax query
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    date: date,
                    eventId: eventId,
                    hour: hour,
                    section: section,
                    mappingId: mappingId,
                    events: events,
                    function: 'updateAnimationToBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    window.location.href = checkoutUrl;
                } else {
                    if(response.status=='quota') {
                        // Show error alert
                        var n = new Noty({
                            type: 'confirm',
                            layout: 'center',
                            theme: 'nest',
                            text: '<p>' + response.noty_message + '</p>',
                            buttons: [
                                Noty.button('<i class="fad fa-repeat-alt"></i> ' + response.noty_button, 'btn btn-success', function () {
                                    n.close();
                                    $('.addEventToBasket').prop('disabled',false);
                                })
                            ]
                        });
                        n.show();
                    } else {
                        alert('ERROR');
                    }
                }
            });

            e.preventDefault();

        });

    }*/

    // Add Product to Basket
    /*function addProductToCheckout() {

        // update product quantity in basket
        $('.updateBasket').click(function(e) {

            // parameters
            var familyCode      = $(this).data('familycode'),
                productCode     = $(this).data('productcode'),
                productPrice    = $(this).data('productprice'),
                action          = $(this).data('action'),
                section         = $(this).data('section'),
                mappingId       = $(this).data('mappingid'),
                eventId         = $(this).data('eventid'),
                quantity        = $('#quantity'+productCode).data('quantity');

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    familyCode: familyCode,
                    productCode: productCode,
                    productPrice: productPrice,
                    action: action,
                    section: section,
                    mappingId: mappingId,
                    function: 'updateProductToBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    window.location.reload();
                } else {
                    alert('Error');
                }
            });

        });

    }*/

    /*function openFooterBasket() {

        // open / Close basket detail
        $('basket .openDetail').click(function(e) {
            $('#basketProductsList').addClass('open');
            $('basket .openDetail').hide();
            $('basket .closeDetail').show();
            $('basket .recap_title').addClass('open');
            $('basket .btn').addClass('open');
        });

        $('basket .closeDetail').click(function(e) {
            $('#basketProductsList').removeClass('open');
            $('basket .closeDetail').hide();
            $('basket .openDetail').show();
            $('basket .recap_title').removeClass('open');
            $('basket .btn').removeClass('open');
        });

    }*/

    function pictogramModal() {

        $(document).on('click','.pictogramModal',function() {

            var pictograms = $(this).data('pictograms');

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    pictograms: pictograms,
                    function: 'getPictograms'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    // Show pictograms in modal
                    var n = new Noty({
                        type: 'confirm',
                        layout: 'center',
                        theme: 'nest',
                        text: response.pictograms,
                        buttons: [
                            Noty.button('<i class="fad fa-times"></i> Fermer', '', function () {
                                n.close();
                            })
                        ]
                    });
                    n.show();
                } else {
                    alert('Error');
                }
            });

        });

    }

    function validateSelection(sid) {

        var valid = true,
            selection = {};

        // Validate MAIN SUBPRODUCT
        $('#form_subproducts_'+sid+' select.subproduct').each(function(index,element) {

            var required        = $(this).data('required'),
                option_value    = $(this).val(),
                pid             = $(this).data('pid');

            if(required=='required' && option_value=='') {
                $(this).parent().addClass('required');
                valid = false;
            } else if(required=='required' && option_value!='') {
                $(this).parent().removeClass('required');
            }

            selection[pid] = {};
            selection[pid]['mapping'] = option_value;

        });

        // VALIDATE REQUIRED DATE
        $('#form_subproducts_'+sid+' [name="available_dates"]').each(function(index,element) {
            var option_value    = $(this).val(),
                pid             = $(this).data('pid');
            if(option_value=='') {
                $(this).parent().addClass('has_error');
                valid = false;
            } else {
               selection[pid]['date'] = option_value;
            }
        });


        // VALIDATE REQUIRED HOURS
        $('#form_subproducts_'+sid+' [name="available_hours"]').each(function(index,element) {
            if(!$(this).parent().hasClass('hidden')) {
                var option_value    = $(this).val(),
                    pid             = $(this).data('pid'),
                    timestamp       = $(this).data('timestamp');
                if(timestamp=='dateonly') {
                    var option_hour     = $(this).data('hour');
                } else {
                    var option_hour     = $('option:selected',this).data('hour');
                }
                if(option_value=='') {
                    $(this).parent().addClass('has_error');
                    $(this).addClass('');
                    valid = false;
                } else if(!$(this).hasClass('hidden')) {
                    selection[pid]['event']     = option_value;
                    selection[pid]['hour']      = option_hour;
                    selection[pid]['timestamp'] = timestamp;
                }
            }
        });

        if(valid==false) {
            $('#form_subproducts_'+sid+' .addProductToBasket').prop('disabled', true);
            return false;
        } else if(valid==true) {
            $('#form_subproducts_'+sid+' .addProductToBasket').prop('disabled', false);
            return selection;
        }

    }

    function validatePresalesSelection() {

        var valid = true,
            selection = {};

        // Validate Main Product
        $('select.select_main_product').each(function(index,element) {

            var option_value    = $(this).val();

            if(option_value=='') {
                $(this).addClass('required');
                valid = false;
            } else if(option_value!='') {
                $(this).parent().removeClass('required');
            }

        });

        // Validate MAIN SUBPRODUCT
        $('select.subproduct').each(function(index,element) {

            var required        = $(this).data('required'),
                option_value    = $(this).val(),
                pid             = $(this).data('pid');

            if(required=='required' && option_value=='') {
                $(this).parent().addClass('required');
                valid = false;
            } else if(required=='required' && option_value!='') {
                $(this).parent().removeClass('required');
            }

            selection[pid] = {};
            selection[pid]['mapping'] = option_value;

        });

        // VALIDATE REQUIRED DATE
        $('input[name="available_dates"]').each(function(index,element) {
            var option_value    = $(this).val(),
                pid             = $(this).data('pid');
            if(option_value=='') {
                $(this).parent().addClass('has_error');
                valid = false;
            } else {
               selection[pid]['date'] = option_value;
            }
        });


        // VALIDATE REQUIRED HOURS
        $('select[name="available_hours"],input[name="available_hours"]').each(function(index,element) {
            if(!$(this).parent().hasClass('hidden')) {
                var option_value    = $(this).val(),
                    pid             = $(this).data('pid'),
                    timestamp       = $(this).data('timestamp');
                if(timestamp=='dateonly') {
                    var option_hour     = $(this).data('hour');
                } else {
                    var option_hour     = $('option:selected',this).data('hour');
                }
                if(option_value=='') {
                    $(this).parent().addClass('has_error');
                    $(this).addClass('');
                    valid = false;
                } else if(!$(this).hasClass('hidden')) {
                    selection[pid]['event']     = option_value;
                    selection[pid]['hour']      = option_hour;
                    selection[pid]['timestamp'] = timestamp;
                }
            }
        });

        if(valid==false) {
            $('.addPresalesToBasket').prop('disabled', true);
            return false;
        } else if(valid==true) {
            $('.addPresalesToBasket').prop('disabled', false);
            return selection;
        }

    }

    function validateGoldpassSelection() {

        var valid = true,
            selection = {},
            totalProducts = 0,
            totalDates = 0,
            totalItems = $('div[id^="timestamp_"]').length; // Count number of items to timestamp

        // Validate Main Product
        $('select.select_main_product').each(function(index,element) {

            var option_value    = $(this).val();

            if(option_value=='') {
                $(this).addClass('required');
                valid = false;
            } else if(option_value!='') {
                $(this).parent().removeClass('required');
            }

        });

        // Validate MAIN SUBPRODUCT
        $('.form.goldpass:not(.hidden) select.subproduct').each(function(index,element) {

            var required        = $(this).data('required'),
                option_value    = $(this).val(),
                pid             = $(this).data('pid');

            if(required=='required' && option_value=='') {
                $(this).parent().addClass('required');
                valid = false;
            } else if(required=='required' && option_value!='') {
                $(this).parent().removeClass('required');
            }

            selection[pid] = {};
            selection[pid]['mapping'] = option_value;

            totalProducts++;

            // update total items if multiple subproducts
            totalItems = totalProducts;

        });

        // VALIDATE REQUIRED DATE
        $('.form.goldpass:not(.hidden) input[name="available_dates"]').each(function(index,element) {
            var option_value    = $(this).val(),
                pid             = $(this).data('pid');
            if(option_value=='') {
                $(this).parent().addClass('has_error');
                valid = false;
            } else {
               selection[pid]['date'] = option_value;
            }
            totalDates++;
        });


        // VALIDATE REQUIRED HOURS
        $('.form.goldpass:not(.hidden) input[name="available_hours"],.form.goldpass:not(.hidden) select[name="available_hours"]').each(function(index,element) {
            if(!$(this).parent().hasClass('hidden')) {
                var option_value    = $(this).val(),
                    pid             = $(this).data('pid'),
                    timestamp       = $(this).data('timestamp');
                if(timestamp=='dateonly') {
                    var option_hour     = $(this).data('hour');
                } else {
                    var option_hour     = $('option:selected',this).data('hour');
                }
                if(option_value=='') {
                    $(this).parent().addClass('has_error');
                    $(this).addClass('');
                    valid = false;
                } else if(!$(this).hasClass('hidden')) {
                    selection[pid]['event']     = option_value;
                    selection[pid]['hour']      = option_hour;
                    selection[pid]['timestamp'] = timestamp;
                }
            }
        });

        if(totalProducts!=totalDates || totalItems!=totalProducts) {
            valid = false;
        }

        if(valid==false) {
            $('.addGoldpassToBasket').prop('disabled', true);
            return false;
        } else if(valid==true) {
            $('.addGoldpassToBasket').prop('disabled', false);
            return selection;
        }

    }

    // PRODUCTS
    //----------------------------------//
    if($('body').hasClass('products_default')) {

        function getTotalQuantity(sid) {

            // Get Total quantity
            var total_quantity = 0;
            $('#sid_'+sid+' input[name^="quantity"]').each(function(index) {
                total_quantity += parseInt($(this)[0].value);
            });
            return total_quantity;

        }

        var timer;
        $('.counterAnimation').on('click',function(e) {

            // Closest block selection is
            var sid = $(this).closest('.product_type').data('sid');

            // reset choice
            $('#form_subproducts_'+sid+' .show_dates').html('');
            $($('#form_subproducts_'+sid+' .subproduct').children()[0]).attr('selected',true);

            // Parameters
            var action          = $(this).data('action'),
                productCode     = $(this).data('productcode'),
                quantity        = parseInt($('#sid_'+sid+' #quantity'+productCode).val());

            // Add / Substract
            if(action=='add') {
                quantity = quantity + 1;
            } else if(action=='substract' && quantity>0) {
                quantity = quantity - 1;
            }

            // minus add opacity
            if(quantity<1 && action=='substract') {
                $('#sid_'+sid+' #minusIcon_'+productCode).css('opacity','0.5');
            } else {
                $('#sid_'+sid+' #minusIcon_'+productCode).css('opacity','1');
            }

            // Update quantity
            $('#sid_'+sid+' #quantity'+productCode).val(quantity);

            var total_quantity = getTotalQuantity(sid);

            if(total_quantity==0) {
                $('#form_subproducts_'+sid).addClass('hidden');
            } else {
                $('#form_subproducts_'+sid).removeClass('hidden');
            }

            clearTimeout(timer);
            timer = setTimeout(function (event) {
                $('#form_subproducts_'+sid+' .subproduct').trigger('change').removeClass('');

            }, 750);

        });

        // update product quantity in basket
        $('.subproduct').on('change',function(e) {

            // parameters
            var option          = $(this).val(),
                timestamp       = $('option:selected', this).data('timestamp'),
                select          = $(this),
                pid             = $(this).data('pid'),
                sid             = $(this).data('sid'),
                quantity        = getTotalQuantity(sid),
                code            = '',
                familycode      = $(this).data('family-code');

            // ONLY for presale
            if($('body').hasClass('presale_timestamp')) {
                quantity        = $('.products_wrapper').data('quantity'),
                code            = $(this).data('code');
            }
            // ONLY for GOLDPASS
            if($('body').hasClass('goldpass_timestamp')) {
                quantity        = $('.products_wrapper').data('quantity'),
                code            = $(this).data('code');
            }

            // Disabled submit button
            $('#form_subproducts_'+sid+' .addProductToBasket').prop('disabled', true);

            // No option selected
            if(option=='' || option==null) {

                $('#show_'+sid+'_'+pid).html('');

            } else {

                $('#show_'+sid+'_'+pid).html('<i class="fas fa-spinner fa-pulse"></i>');

                $.ajax({
                    type: 'POST',
                    url: ajaxLang + '/ajax',
                    data: {
                        option: option,
                        pid: pid,
                        sid: sid,
                        timestamp: timestamp,
                        quantity: quantity,
                        code:code,
                        familycode:familycode,
                        function: 'getProductDetail'
                    },
                    dataType: "json",
                    cache: false
                }).done(function (response) {

                    if(response.status=='success') {

                        // Only for WABO
                        if(familycode=='WABO') {

                            // show text
                            $('#show_'+sid+'_'+pid).html(response.rendering);
                            // Validate selection
                            if($('body').hasClass('presale_timestamp')) {
                                validatePresalesSelection();
                            } else {
                                validateSelection(sid);
                            }

                        } else if(timestamp=='presale') {

                            // show text
                            $('#show_'+sid+'_'+pid).html(response.rendering);
                            // Validate selection
                            validateSelection(sid);

                        } else {

                            // Dates availables
                            if(response.dates=='yes') {

                                // array
                                var datess = response.datess;
                                // show slots
                                $('#show_'+sid+'_'+pid).html(response.rendering);
                                // Render datepicker with language
                                $('#datepicker_'+sid+'_'+pid).datepicker({
                                    dateFormat: 'dd/mm/yy',
                                    minDate:response.datePickerStart,
                                    maxDate:response.endOfSeason,
                                    firstDay:1,
                                    beforeShowDay: function(date){
                                        var string = $.datepicker.formatDate('yy-mm-dd', date);
                                        return [ datess.indexOf(string) == -1 ]
                                    },
                                    onSelect: function(date) {

                                        var ddmmyy  = date.split('/'),
                                            dd      = ddmmyy[0],
                                            mm      = ddmmyy[1],
                                            yy      = ddmmyy[2],
                                            jsDate  = yy + mm + dd,
                                            phpDate = yy + '-' + mm + '-' + dd;

                                        $('#hours_'+sid+'_'+pid+' > select[name="available_hours"]').html('<option value="">Loading...</option>').prop('selectedIndex',0);

                                        $(this).parent().removeClass('has_error');

                                        // Validate selection
                                        // ONLY for presale
                                        /*if($('body').hasClass('presale_timestamp')) {
                                            validatePresalesSelection();
                                        // ONLY for GOLDPASS
                                        } else if($('body').hasClass('goldpass_timestamp')) {
                                            validateGoldpassSelection();
                                        } else {
                                            validateSelection(sid);
                                        }*/

                                        // Load available slots for selected date
                                        $.ajax({
                                            type: 'POST',
                                            url: ajaxLang + '/ajax',
                                            data: {
                                                option: option,
                                                pid: pid,
                                                sid: sid,
                                                timestamp: timestamp,
                                                quantity: quantity,
                                                code:code,
                                                familycode:familycode,
                                                date:phpDate,
                                                function: 'getSlotsForDate'
                                            },
                                            dataType: "json",
                                            cache: false
                                        }).done(function (response) {

                                            // If slots, append them in the select
                                            if(timestamp=='datehour') {
                                                $('#hours_'+sid+'_'+pid+' > select[name="available_hours"]').html(response.options);
                                            // if no slots (date only) remove select and add hidden input
                                            } else if(timestamp=='dateonly') {
                                                if(response.status=='success') {
                                                    // remove select
                                                    $('#hours_'+sid+'_'+pid+' > select[name="available_hours"]').remove();
                                                    // add hidden input with event_id
                                                    $('#hours_'+sid+'_'+pid).html(response.options);
                                                } else if(response.status=='error') {
                                                    $('#hours_'+sid+'_'+pid).html(response.options);
                                                }
                                            }

                                            // Validate selection
                                            // ONLY for presale
                                            if($('body').hasClass('presale_timestamp')) {
                                                validatePresalesSelection();
                                            // ONLY for GOLDPASS
                                            } else if($('body').hasClass('goldpass_timestamp')) {
                                                validateGoldpassSelection();
                                            } else {
                                                validateSelection(sid);
                                            }

                                        });
                                    }
                                });

                            // No dates available
                            } else if(response.dates=='no') {

                                $('#show_'+sid+'_'+pid).html('');

                            }

                            select.parent().removeClass('required');
                        }
                    } else {
                        alert('Error loading data');
                    }
                });

            }

        });

        // Trigger change each select
        if($('body').hasClass('presale_timestamp')) {
            $('.subproduct').trigger('change');
        }
        // Do not trigger in GoldPass, user must choose a product first

        // Change Date
        $(document).on('change','.requiredDate,.requiredHour',function() {
            var optionValue = $(this).val(),
                sid         = $(this).data('sid');
            if(optionValue=='') {
                $(this).parent().addClass('has_error');
            } else {
                $(this).parent().removeClass('has_error');
            }
            // Validate selection
            // ONLY for presale
            if($('body').hasClass('presale_timestamp')) {
                validatePresalesSelection();
            // ONLY for GOLDPASS
            } else if($('body').hasClass('goldpass_timestamp')) {
                validateGoldpassSelection();
            } else {
                validateSelection(sid);
            }
        })

        // Change Hour
        $(document).on('change','.available_hours',function() {
            var optionValue = $(this).val(),
                sid         = $(this).data('sid');
            if(optionValue=='') {
                $(this).parent().addClass('has_error');
            } else {
                $(this).parent().removeClass('has_error');
            }
            // Validate selection
            // ONLY for presale
            if($('body').hasClass('presale_timestamp')) {
                validatePresalesSelection();
            // ONLY for GOLDPASS
            } else if($('body').hasClass('goldpass_timestamp')) {
                validateGoldpassSelection();
            } else {
                validateSelection(sid);
            }
        })



        // SUBMIT FORM PRODUCTS PAGE
        $('form.products').submit(function(e) {

            e.preventDefault();

            var sid             = $(this).data('sid'),
                type            = $('#form_subproducts_'+sid+' .addProductToBasket').data('type'),
                error           = false;

            // Verify all fields are filled
            translations['fr']['producterror'] = '<strong>Attention !</strong><br/>Veuillez vérifier que tous les champs "Dates" et "Heure de visite" sont correctement remplis.';
            translations['nl']['producterror'] = '<strong>Opgelet !</strong><br/>Gelieve te controleren of je alle "Data" en "Vertrekuren" van de bezoeken hebt ingevuld.';
            translations['en']['producterror'] = '<strong>Important !</strong><br/>Please check that all "Dates" and "Times of visit" fields are correctly filled in.';
            translations['de']['producterror'] = '<strong>Achtung !</strong><br/>Bitte überprüfen Sie, ob alle "Datums- und Uhrzeitfelder des Besuchs" korrekt ausgefüllt sind. ';
            translations['fr']['producterrorbutton'] = 'Vérifier';
            translations['nl']['producterrorbutton'] = 'Controleren';
            translations['en']['producterrorbutton'] = 'Check';
            translations['de']['producterrorbutton'] = 'Prüfen';

            // Dates
            $('#form_subproducts_'+sid+' input[name="available_dates"]').each(function() {
                if($(this).val()==null || $(this).val()=='') {
                    error = true;
                }
            });
            // Hours
            $('#form_subproducts_'+sid+' select[name="available_hours"]').each(function() {
                if($('option:selected', this).val()==null || $('option:selected', this).val()=='') {
                    error = true;
                }
            });
            // Hidden hours
            $('#form_subproducts_'+sid+' input[name="available_hours"]').each(function() {
                if($(this).val()==null || $(this).val()=='') {
                    error = true;
                }
            });

            if(error==true) {

                // Show error alert
                var n = new Noty({
                    type: 'error',
                    layout: 'center',
                    theme: 'nest',
                    text: '<p>'+translations[ajaxLang].producterror+'</p>',
                    buttons: [
                        Noty.button(translations[ajaxLang].producterrorbutton, 'btn btn-alert btn-noty-right', function () {
                            n.close();
                        })
                    ],
                    closeWith:['button']
                });
                n.show();

            } else {

                if(type=='mainproduct') {

                    var date            = $('#datepicker_'+sid+'_1').val(),
                        timestamp       = $('#form_subproducts_'+sid+' .subproduct option:selected').data('timestamp'),
                        section         = $('#form_subproducts_'+sid+' .addProductToBasket').data('section'),
                        mappingId       = $('#form_subproducts_'+sid+' .addProductToBasket').data('mappingid'),
                        checkoutUrl     = $(this).data('checkout');

                    if(timestamp=='dateonly') {
                        var eventId     = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('input[name="available_hours"]').val(),
                            hour        = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('input[name="available_hours"]').data('hour');
                    } else if(timestamp=='datehour') {
                        var eventId     = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('select[name="available_hours"]').val(),
                            hour        = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('select[name="available_hours"] option:selected').data('hour');
                    } else if(timestamp=='nodates' || timestamp=='presale') {
                        var eventId     = '0',
                            hour        = '0',
                            date        = '0';
                    }

                    // process products and save in events array
                    var events = {};
                    $('#sid_'+sid+' input[name^="quantity"]').each(function(index) {

                        var familyCode      = $(this)[0].dataset.familycode,
                            productCode     = $(this)[0].dataset.productcode,
                            quantity        = $(this)[0].value;
                        if(quantity>0) {
                            // create array if not exists
                            if(events[familyCode]==undefined) { events[familyCode] = {}; }
                            // create array if not exists
                            events[familyCode][productCode] = quantity;
                        }
                    })

                    // Disabled submit button
                    $('#form_subproducts_'+sid+' .addProductToBasket').prop('disabled', true);

                    // ajax query
                    $.ajax({
                        type: 'POST',
                        url: ajaxLang + '/ajax',
                        data: {
                            date: date,
                            eventId: eventId,
                            hour: hour,
                            section: section,
                            mappingId: mappingId,
                            events: events,
                            timestamp: timestamp,
                            function: 'addProductSingleToBasket'
                        },
                        dataType: "json",
                        cache: false,
                    }).done(function (response) {
                        if(response.status=='success') {
                            // Add quantity to basket
                            $('#basketHeaderTotal').html(response.total);
                            // Update Countdown and (re)init
                            $('#timer > .countdown').remove();
                            $('#timer').append('<span class="countdown" data-timestamp="'+response.countdown.timestamp+'">'+response.countdown.value +'</span>');
                            initCountdown();
                            // Show error alert
                            var n = new Noty({
                                type: 'confirm',
                                layout: 'center',
                                theme: 'nest',
                                text: '<p>' + response.noty_message + '</p>',
                                buttons: [
                                    Noty.button('<i class="far fa-shopping-bag"></i>&nbsp;&nbsp;'+response.noty_button_checkout, 'btn btn-success btn-noty-left', function () {
                                        window.location.href = checkoutUrl;
                                    }),
                                    Noty.button(response.noty_button_stayonpage, 'btn btn-success btn-noty-right', function () {
                                        // reset block to 0
                                        $('#sid_'+sid+' input[name^="quantity"]').val(0);
                                        $('#form_subproducts_'+sid).addClass('hidden');
                                        $('div[id^="show_'+sid+'"]').html('');
                                        n.close();
                                    })
                                ]
                            });
                            n.show();
                        } else {
                            if(response.status=='quota') {
                                // Show error alert
                                var n = new Noty({
                                    type: 'confirm',
                                    layout: 'center',
                                    theme: 'nest',
                                    text: '<p>' + response.noty_message + '</p>',
                                    buttons: [
                                        Noty.button('<i class="fad fa-repeat-alt"></i>&nbsp;&nbsp;' + response.noty_button, 'btn btn-success btn-noty-left', function () {
                                            n.close();
                                            $('.addEventToBasket').prop('disabled',false);
                                        })
                                    ]
                                });
                                n.show();
                            } else {
                                alert('ERROR');
                            }
                        }
                    });

                } else if(type=='subproducts') {

                    var response        = validateSelection(sid),
                        products        = {},
                        mappingId       = $('#form_subproducts_'+sid+' .addProductToBasket').data('mappingid'),
                        section         = $('#form_subproducts_'+sid+' .addProductToBasket').data('section'),
                        familyCode      = '',
                        checkoutUrl     = $(this).data('checkout');

                    // get number of product
                    $('#sid_'+sid+' input[name^="quantity"]').each(function() {
                        var quantity    = parseInt($(this).val()),
                            productCode = $(this).data('productcode');
                            familyCode  = $(this).data('familycode');
                        if(quantity>=1) {
                            products[productCode] = quantity;
                        }
                    })

                    if(response==false) {

                        // form submitted but not ok
                        alert('Error while loading selection.');

                    } else {

                        $('#form_subproducts_'+sid+' .addProductToBasket').prop('disabled',true);

                        $.ajax({
                            type: 'POST',
                            url: ajaxLang + '/ajax',
                            data: {
                                options: response,
                                mappingId: mappingId,
                                familyCode: familyCode,
                                products: products,
                                section: section,
                                function: 'addProductMultipleToBasket'
                            },
                            dataType: "json",
                            cache: false,
                        }).done(function (response) {
                            if(response.status=='success') {

                                // Add quantity to basket
                                $('#basketHeaderTotal').html(response.total);

                                // Show error alert
                                var n = new Noty({
                                    type: 'confirm',
                                    layout: 'center',
                                    theme: 'nest',
                                    text: '<p>' + response.noty_message + '</p>',
                                    buttons: [
                                        Noty.button('<i class="far fa-shopping-bag"></i>&nbsp;&nbsp;' + response.noty_button_checkout, 'btn btn-success btn-noty-left', function () {
                                            window.location.href = checkoutUrl;
                                        }),
                                        Noty.button(response.noty_button_stayonpage, 'btn btn-success btn-noty-right', function () {
                                            // reset block to 0
                                            $('#sid_'+sid+' input[name^="quantity"]').val(0);
                                            $('#form_subproducts_'+sid).addClass('hidden');
                                            $('div[id^="show_'+sid+'"]').html('');
                                            n.close();
                                        })
                                    ],
                                    closeWith:['button']
                                });
                                n.show();

                            } else {
                                if(response.status=='quota') {
                                    // Show error alert
                                    var n = new Noty({
                                        type: 'confirm',
                                        layout: 'center',
                                        theme: 'nest',
                                        text: '<p>' + response.noty_message + '</p>',
                                        buttons: [
                                            Noty.button('<i class="fad fa-repeat-alt"></i>&nbsp;&nbsp;' + response.noty_button, 'btn btn-success btn-noty-left', function () {
                                                n.close();
                                                $('.addProductToBasket').prop('disabled',false);
                                            })
                                        ]
                                    });
                                    n.show();
                                } else {
                                    alert('Error during form submission.');
                                }
                            }
                        });

                    }

                }

            }

        });


        // SUBMIT FORM PRESALES FORM
        $('.addPresalesToBasket').click(function() {

            var everythingIsOk  = true,
                detailsUrl      = $(this).data('details');

            // Set button hidden
            $('.addPresalesToBasket').addClass('hidden');

            setTimeout(function(){

                // Loop on each forms
                $('form.presales').each(function(e) {

                    var sid             = $(this).data('sid'),
                        type            = $('#form_subproducts_'+sid).data('type'),
                        presaleCode     = $(this).data('code');

                    if(type=='mainproduct') {

                        var date            = $('#datepicker_'+sid+'_1').val(),
                            timestamp       = $('#form_subproducts_'+sid+' .subproduct option:selected').data('timestamp'),
                            section         = $('#form_subproducts_'+sid).data('section'),
                            mappingId       = $('#form_subproducts_'+sid).data('mappingid'),
                            checkoutUrl     = $(this).data('checkout');

                        if(timestamp=='dateonly') {
                            var eventId     = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('input[name="available_hours"]').val(),
                                hour        = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('input[name="available_hours"]').data('hour');
                        } else if(timestamp=='datehour') {
                            var eventId     = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('select[name="available_hours"]').val(),
                                hour        = $('div[id^="hours_'+sid+'_1"]').not('.hidden').find('select[name="available_hours"] option:selected').data('hour');
                        } else if(timestamp=='nodates') {
                            var eventId     = '0',
                                hour        = '0',
                                date        = '0';
                        }

                        // process products and save in events array
                        var events = {};
                        $('#sid_'+sid+' input[name^="quantity"]').each(function(index) {

                            var familyCode      = $(this)[0].dataset.familycode,
                                productCode     = $(this)[0].dataset.productcode,
                                quantity        = $(this)[0].value;
                            if(quantity>0) {
                                // create array if not exists
                                if(events[familyCode]==undefined) { events[familyCode] = {}; }
                                // create array if not exists
                                events[familyCode][productCode] = quantity;
                            }
                        })

                        // ajax query
                        $.ajax({
                            type: 'POST',
                            url: ajaxLang + '/ajax',
                            data: {
                                date: date,
                                eventId: eventId,
                                hour: hour,
                                section: section,
                                mappingId: mappingId,
                                events: events,
                                timestamp: timestamp,
                                presaleCode: presaleCode,
                                function: 'addPresalesSingleToBasket'
                            },
                            dataType: "json",
                            cache: false,
                            async: false,
                        }).done(function (response) {
                            if(response.status=='success') {
                                $('#timestamp_'+sid).addClass('added');
                                $('#timestamp_'+sid).find('.removeCode').remove();
                            } else {
                                everythingIsOk = false;
                                if(response.status=='quota') {
                                    $('#form_subproducts_'+sid).addClass('quota');
                                    $('.addPresalesToBasket').removeClass('hidden');
                                } else {
                                    alert('ERROR');
                                    $('.addPresalesToBasket').removeClass('hidden');
                                }
                            }
                        });

                    } else if(type=='subproducts') {

                        var response        = validateSelection(sid),
                            products        = {},
                            mappingId       = $('#form_subproducts_'+sid).data('mappingid'),
                            section         = $('#form_subproducts_'+sid).data('section'),
                            familyCode      = '',
                            checkoutUrl     = $(this).data('checkout');

                        // get number of product
                        $('#sid_'+sid+' input[name^="quantity"]').each(function() {
                            var quantity    = parseInt($(this).val()),
                                productCode = $(this).data('productcode');
                                familyCode  = $(this).data('familycode');
                            if(quantity>=1) {
                                products[productCode] = quantity;
                            }
                        })

                        if(response==false) {

                            // form submitted but not ok
                            alert('Error while loading selection.');

                        } else {

                            $.ajax({
                                type: 'POST',
                                url: ajaxLang + '/ajax',
                                data: {
                                    options: response,
                                    mappingId: mappingId,
                                    familyCode: familyCode,
                                    products: products,
                                    section: section,
                                    presaleCode: presaleCode,
                                    function: 'addPresalesMultipleToBasket'
                                },
                                dataType: "json",
                                cache: false,
                                async: false,
                            }).done(function (response) {
                                if(response.status=='success') {
                                    $('#timestamp_'+sid).addClass('added');
                                    $('#timestamp_'+sid).find('.removeCode').remove();
                                } else {
                                    everythingIsOk = false;
                                    if(response.status=='quota') {
                                        $('#form_subproducts_'+sid).addClass('quota');
                                        $('.addPresalesToBasket').removeClass('hidden');
                                    } else {
                                        alert('ERROR');
                                        $('.addPresalesToBasket').removeClass('hidden');
                                    }
                                }
                            });

                        }

                    }

                });

                if(everythingIsOk==true) {
                    window.location.href = detailsUrl;
                }

            }, 100);

        });

        // SUBMIT FORM GOLDPASS PRODUCTS
        $('.addGoldpassToBasket').click(function() {

            var everythingIsOk  = true,
                detailsUrl      = $(this).data('details');

            // Set button hidden
            $('.addGoldpassToBasket').addClass('hidden');

            setTimeout(function(){

                // Loop on each forms
                $('.form.goldpass:not(.hidden)').each(function(e) {

                    var sid             = $(this).data('sid'),
                        pid             = $(this).data('pid'),
                        type            = $('#form_subproducts_'+sid+'_'+pid).data('type'),
                        goldpassCode    = $(this).data('code');

                    if(type=='mainproduct') {

                        var date            = $(this).find('input[id^="datepicker_"]').val(),
                            timestamp       = $(this).find('.subproduct option:selected').data('timestamp'),
                            section         = $(this).data('section'),
                            mappingId       = $(this).data('mappingid'),
                            checkoutUrl     = $(this).data('checkout'),
                            familyCode      = $(this).data('familycode'),
                            productCode     = $(this).data('productcode'),
                            priceUnit       = $(this).find('.subproduct option:selected').data('price-unit'),
                            events          = {};

                            events[familyCode]  = {};
                            events[familyCode][productCode] = 1;

                        if(timestamp=='dateonly') {
                            var eventId     = $(this).find('div[id^="hours_"]').not('.hidden').find('input[name="available_hours"]').val(),
                                hour        = $(this).find('div[id^="hours_"]').not('.hidden').find('input[name="available_hours"]').data('hour');
                        } else if(timestamp=='datehour') {
                            var eventId     = $(this).find('div[id^="hours_"]').not('.hidden').find('select[name="available_hours"]').val(),
                                hour        = $(this).find('div[id^="hours_"]').not('.hidden').find('select[name="available_hours"] option:selected').data('hour');
                        }

                        // ajax query
                        $.ajax({
                            type: 'POST',
                            url: ajaxLang + '/ajax',
                            data: {
                                date: date,
                                eventId: eventId,
                                hour: hour,
                                section: section,
                                mappingId: mappingId,
                                events: events,
                                timestamp: timestamp,
                                goldpassCode: goldpassCode,
                                priceUnit: priceUnit,
                                function: 'addGoldpassSingleToBasket'
                            },
                            dataType: "json",
                            cache: false,
                            async: false,
                        }).done(function (response) {
                            if(response.status=='success') {
                                $('#timestamp_'+sid).addClass('added');
                                $('#timestamp_'+sid).find('.removeCode').remove();
                            } else {
                                everythingIsOk = false;
                                if(response.status=='quota') {
                                    $('#form_subproducts_'+sid).addClass('quota');
                                    $(this).prop('disabled',false);
                                } else {
                                    alert('ERROR');
                                    $(this).prop('disabled',false);
                                }
                            }
                        });

                    } else if(type=='subproducts') {

                        var response        = validateSelection(sid+'_'+pid),
                            products        = {},
                            mappingId       = $('#form_subproducts_'+sid+'_'+pid).data('mappingid'),
                            section         = $('#form_subproducts_'+sid+'_'+pid).data('section'),
                            familyCode      = $('#form_subproducts_'+sid+'_'+pid).data('familycode'),
                            checkoutUrl     = $(this).data('checkout');

                        // get number of product
                        $('#sid_'+sid+' .product_'+sid+':not(.hidden) input[name^="quantity"]').each(function() {
                            var quantity    = parseInt($(this).val()),
                                productCode = $(this).data('productcode');
                                familyCode  = $(this).data('familycode');
                            if(quantity>=1) {
                                products[productCode] = quantity;
                            }
                        })

                        if(response==false) {

                            // form submitted but not ok
                            alert('Error while loading selection.');

                        } else {

                            $.ajax({
                                type: 'POST',
                                url: ajaxLang + '/ajax',
                                data: {
                                    options: response,
                                    mappingId: mappingId,
                                    familyCode: familyCode,
                                    products: products,
                                    section: section,
                                    goldpassCode: goldpassCode,
                                    function: 'addGoldpassMultipleToBasket'
                                },
                                dataType: "json",
                                cache: false,
                                async: false,
                            }).done(function (response) {
                                if(response.status=='success') {
                                    $('#timestamp_'+sid).addClass('added');
                                    $('#timestamp_'+sid).find('.removeCode').remove();
                                } else {
                                    everythingIsOk = false;
                                    if(response.status=='quota') {
                                        $('#form_subproducts_'+sid).addClass('quota');
                                        $('.addGoldpassToBasket').removeClass('hidden');
                                    } else {
                                        alert('ERROR');
                                        $('.addGoldpassToBasket').removeClass('hidden');
                                    }
                                }
                            });

                        }

                    } /*else if(type=='subproducts') {

                        var response        = validateSelection(sid),
                            products        = {},
                            mappingId       = $('#form_subproducts_'+sid).data('mappingid'),
                            section         = $('#form_subproducts_'+sid).data('section'),
                            familyCode      = '',
                            checkoutUrl     = $(this).data('checkout');

                        // get number of product
                        $('#sid_'+sid+' input[name^="quantity"]').each(function() {
                            var quantity    = parseInt($(this).val()),
                                productCode = $(this).data('productcode');
                                familyCode  = $(this).data('familycode');
                            if(quantity>=1) {
                                products[productCode] = quantity;
                            }
                        })

                        if(response==false) {

                            // form submitted but not ok
                            alert('Error while loading selection.');

                        } else {

                            $.ajax({
                                type: 'POST',
                                url: ajaxLang + '/ajax',
                                data: {
                                    options: response,
                                    mappingId: mappingId,
                                    familyCode: familyCode,
                                    products: products,
                                    section: section,
                                    function: 'addPresalesMultipleToBasket' // TODO
                                },
                                dataType: "json",
                                cache: false,
                            }).done(function (response) {
                                if(response.status=='success') {
                                    $('#form_subproducts_'+sid).addClass('added');
                                } else {
                                    everythingIsOk = false;
                                    if(response.status=='quota') {
                                        $('#form_subproducts_'+sid).addClass('quota');
                                    } else {
                                        alert('Error during form submission.');
                                    }
                                }
                            });

                        }

                    }*/

                });

                if(everythingIsOk==true) {
                    window.location.href = detailsUrl;
                }

            }, 100);

        });

    }


    // PRESALES CODE VALIDATION
    //----------------------------------//

    var codeNotValidLocale      = {"fr":"Ce code n'est pas valable",
                                   "nl":"Deze code is niet geldig",
                                   "en":"This code is not valid",
                                   "de":"Dieser Code ist nicht gültig"};
    var codeAlreadyUsedLocale   = {"fr":"Vous avez déjà intrduit ce code",
                                   "nl":"U heeft deze code al ingevoerd",
                                   "en":"You have already entered this code",
                                   "de":"Sie haben diesen Code bereits eingegeben"};
    var validationLocale        = {"fr":"Valider",
                                   "nl":"Valideren",
                                   "en":"Validation",
                                   "de":"Validieren"};
    var cancelLocale            = {"fr":"Annuler",
                                   "nl":"Annuleren",
                                   "en":"Cancel",
                                   "de":"Abbrechen"};

    if($('body').hasClass('presales')) {

        var validatedCodes  = [];

        $('.validate').text(validationLocale[ajaxLang]);

        $('input[name^="codes["]').focus(function() {
            $(this).parent('.code').find('.prepend').addClass('focus');
        })
        $('input[name^="codes["]').focusout(function() {
            $(this).parent('.code').find('.prepend').removeClass('focus');
        })

        $(document).on('click','.validate', function() {

            // Var
            var serie           = $(this).data('c'),
                code            = $('input[name="codes['+serie+']"]').val();

            // hide validate button, show loader and set input readonly
            $(this).addClass('hidden');
            $(this).parent().find('.validation').removeClass('hidden');
            $(this).parent().find('.error').addClass('hidden');
            $('input[name="codes['+serie+']"]').prop('readonly', true);

            // check code only if not already set
            var codeCheck = 0;
            $('input[name^="codes["]').each(function(i,e) {
                if(code==$(this).val()) {
                    codeCheck++;
                }
            })

            // Code already set
            if(codeCheck>1) {

                // remove loader
                $('#code_'+serie+' .validation').addClass('hidden');

                $('#code_'+serie+' .error span').text(codeAlreadyUsedLocale[ajaxLang]);
                $('#code_'+serie+' .error').removeClass('hidden');
                $('#code_'+serie+' .validate').removeClass('hidden');
                $('input[name="codes['+serie+']"]').prop('readonly', false);

            // Code verification
            } else {

                // AJAX CODE VERIFICATION
                $.ajax({
                    type: 'POST',
                    url: ajaxLang + '/ajax',
                    data: {
                        code: code,
                        function: 'validatePresale'
                    },
                    dataType: "json",
                    cache: false,
                }).done(function (response) {

                    // remove loader
                    $('#code_'+serie+' .validation').addClass('hidden');

                    if(response.status=='success') {

                        // Valid
                        $('#code_'+serie+' .prepend').addClass('hidden');
                        $('#code_'+serie+' .prepend_valid').removeClass('hidden');
                        $('input[name="codes['+serie+']"]').addClass('valid');
                        // add remove button
                        $('#code_'+serie+' .remove').removeClass('hidden');
                        // show button add new code
                        $('.add_presale').removeClass('hidden');
                        // Add code to array
                        validatedCodes.push(code);
                        $('input[name="presales_code"]').val(validatedCodes);

                        if(validatedCodes=='') {
                            $('#presales_validation').addClass('hidden');
                        } else {
                            $('#presales_validation').removeClass('hidden');
                        }

                    } else if(response.status=='error') {

                        $('#code_'+serie+' .error span').text(codeNotValidLocale[ajaxLang]);
                        $('#code_'+serie+' .error').removeClass('hidden');
                        $('#code_'+serie+' .validate').removeClass('hidden');
                        $('input[name="codes['+serie+']"]').prop('readonly', false);

                    }

                });

            }

        });

        $(document).on('click','.add_presale', function() {

            // add new block
            var newCode = '',
                serie = $(this).data('c'),
                newSerie = parseInt(serie+1);

            // update button value
            $(this).data('c', newSerie);

            newCode += '<span class="code" id="code_'+newSerie+'">';
                newCode += '<span class="prepend"><i class="fal fa-font-case fa-fw"></i></span>';
                newCode += '<span class="prepend_valid hidden"><i class="fal fa-spell-check fa-fw"></i></span>';
                newCode += '<input type="text" value="" name="codes['+newSerie+']" maxlength="21" />';
                newCode += '<span class="validate" data-c="'+newSerie+'">'+validationLocale[ajaxLang]+'</span>';
                newCode += '<span class="validation hidden"><i class="fas fa-spinner fa-spin"></i></span>';
                newCode += '<span class="error hidden"><i class="fal fa-exclamation-circle"></i> <span></span></span>';
                newCode += '<span class="remove hidden"><i class="fal fa-trash-alt"></i></span>';
            newCode += '</span>';

            $('.codes').append(newCode);
            $(this).addClass('hidden');

        });

        $(document).on('click','.remove', function() {

            // Get code to remove
            var codeToDel = $(this).parent('.code').find('input[name^="code"]').val();
            $(this).parent('.code').remove();
            var updateCodes = jQuery.grep(validatedCodes, function(a) {
              return a !== codeToDel;
            });
            validatedCodes = updateCodes;
            $('input[name="presales_code"]').val(validatedCodes);

            if(validatedCodes=='') {
                $('#presales_validation').addClass('hidden');
            } else {
                $('#presales_validation').removeClass('hidden');
            }

        });

        $('#presales_validation').submit(function(e) {

            e.preventDefault();

            var presales_codes   = $('input[name="presales_code"]').val(),
                timestampUrl    = $(this).attr('action');

            // ADD CODES TO BASKETS AND GO TO TIMESTAMP
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    presalesCodes: presales_codes,
                    function: 'addPresaleCodesToBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    // redirect to timestamp
                    window.location.href = timestampUrl;
                }
            });

        })

    }


    // PRESALE TIMESTAMP
    //----------------------------------//
    if($('body').hasClass('presale_timestamp')) {

        // Use part of logic of products page

        // Custom from timestamp
        $('.removeCode').click(function() {

            // variables
            var code = $(this).data('code'),
                sid  = $(this).data('sid'),

                n = new Noty({
                type: 'confirm',
                layout: 'center',
                theme: 'nest',
                text: '<p>Voulez-vous retirer le code <code><strong>'+code+'</strong></code> de votre sélection ?<br/>Il sera ré-utilisable lors d\'une prochaine Réservation.</p>',
                buttons: [
                    Noty.button(cancelLocale[ajaxLang], 'btn btn-red btn-noty-left', function () {
                        // annuler
                        n.close();
                    }),
                    Noty.button(validationLocale[ajaxLang], 'btn btn-success btn-noty-right', function () {
                        // set code to unused
                        $.ajax({
                            type: 'POST',
                            url: ajaxLang + '/ajax',
                            data: {
                                code: code,
                                function: 'setPresaleCodeUnused'
                            },
                            dataType: "json",
                            cache: false,
                        }).done(function (response) {
                            // delete block
                            $('#timestamp_'+sid).fadeOut(100).remove();
                            if(response.stillCodes=='no') {
                                $('#stillCodes').removeClass('hidden');
                                $('.addPresalesToBasket').remove();
                            }
                            n.close();
                        });
                    })
                ],
                closeWith:['button']
            });
            n.show();

        })

        $('select.subproduct').on('change',function() {
            validatePresalesSelection();
        })


    };





    // GOLDPASS & COCOON VILLAGE CODE VALIDATION
    //----------------------------------//

    if($('body').hasClass('goldpass')) {

        var validatedCodes  = [];

        $('.validate').text(validationLocale[ajaxLang]);

        $(document).on('focus','input[name^="codes["]', function() {
            $(this).parent('.code').find('.prepend').addClass('focus');
        })
        $(document).on('focusout','input[name^="codes["]', function() {
            $(this).parent('.code').find('.prepend').removeClass('focus');
        })

        $(document).on('click','.validate', function() {

            // Var
            var serie           = $(this).data('c'),
                code            = $('input[name="codes['+serie+']"]').val().toUpperCase();

            // hide validate button, show loader and set input readonly
            $(this).addClass('hidden');
            $(this).parent().find('.validation').removeClass('hidden');
            $(this).parent().find('.error').addClass('hidden');
            $('input[name="codes['+serie+']"]').prop('readonly', true);

            // check code only if not already set
            var codeCheck = 0;
            $('input[name^="codes["]').each(function(i,e) {
                if(code==$(this).val().toUpperCase()) {
                    codeCheck++;
                }
            })

            // Code already set
            if(codeCheck>1) {

                // remove loader
                $('#code_'+serie+' .validation').addClass('hidden');

                $('#code_'+serie+' .error span').text(codeAlreadyUsedLocale[ajaxLang]);
                $('#code_'+serie+' .error').removeClass('hidden');
                $('#code_'+serie+' .validate').removeClass('hidden');
                $('input[name="codes['+serie+']"]').prop('readonly', false);

            // Code verification
            } else {

                // AJAX CODE VERIFICATION
                $.ajax({
                    type: 'POST',
                    url: ajaxLang + '/ajax',
                    data: {
                        code: code,
                        function: 'validateGoldpass'
                    },
                    dataType: "json",
                    cache: false,
                }).done(function (response) {

                    // remove loader
                    $('#code_'+serie+' .validation').addClass('hidden');

                    if(response.status=='success') {

                        // Valid
                        $('#code_'+serie+' .prepend').addClass('hidden');
                        $('#code_'+serie+' .prepend_valid').removeClass('hidden');
                        $('input[name="codes['+serie+']"]').addClass('valid');
                        // add remove button
                        $('#code_'+serie+' .remove').removeClass('hidden');
                        // show button add new code
                        $('.add_goldpass').removeClass('hidden');
                        // Add code to array
                        validatedCodes.push(code);
                        $('input[name="goldpass_code"]').val(validatedCodes);

                        if(validatedCodes=='') {
                            $('#goldpass_validation').addClass('hidden');
                        } else {
                            $('#goldpass_validation').removeClass('hidden');
                        }

                    } else if(response.status=='error') {

                        $('#code_'+serie+' .error span').text(codeNotValidLocale[ajaxLang]);
                        $('#code_'+serie+' .error').removeClass('hidden');
                        $('#code_'+serie+' .validate').removeClass('hidden');
                        $('input[name="codes['+serie+']"]').prop('readonly', false);

                    }

                });

            }

        });

        $(document).on('click','.add_goldpass', function() {

            // add new block
            var newCode = '',
                serie = $(this).data('c'),
                newSerie = parseInt(serie+1);

            // update button value
            $(this).data('c', newSerie);

            newCode += '<span class="code" id="code_'+newSerie+'">';
                newCode += '<span class="prepend"><i class="fal fa-font-case fa-fw"></i></span>';
                newCode += '<span class="prepend_valid hidden"><i class="fal fa-spell-check fa-fw"></i></span>';
                newCode += '<input type="text" value="" name="codes['+newSerie+']" maxlength="21" />';
                newCode += '<span class="validate" data-c="'+newSerie+'">'+validationLocale[ajaxLang]+'</span>';
                newCode += '<span class="validation hidden"><i class="fas fa-spinner fa-spin"></i></span>';
                newCode += '<span class="error hidden"><i class="fal fa-exclamation-circle"></i> <span></span></span>';
                newCode += '<span class="remove hidden"><i class="fal fa-trash-alt"></i></span>';
            newCode += '</span>';

            $('.codes').append(newCode);
            $(this).addClass('hidden');

        });

        $(document).on('click','.remove', function() {

            // Get code to remove
            var codeToDel = $(this).parent('.code').find('input[name^="code"]').val();
            $(this).parent('.code').remove();
            var updateCodes = jQuery.grep(validatedCodes, function(a) {
              return a !== codeToDel;
            });
            validatedCodes = updateCodes;
            $('input[name="goldpass_code"]').val(validatedCodes);

            if(validatedCodes=='') {
                $('#goldpass_validation').addClass('hidden');
            } else {
                $('#goldpass_validation').removeClass('hidden');
            }

        });

        $('#goldpass_validation').submit(function(e) {

            e.preventDefault();

            var goldpass_codes   = $('input[name="goldpass_code"]').val(),
                timestampUrl    = $(this).attr('action');

            // ADD CODES TO BASKETS AND GO TO TIMESTAMP
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    goldpassCodes: goldpass_codes,
                    function: 'addGoldpassCodesToBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    // redirect to timestamp
                    window.location.href = timestampUrl;
                }
            });

        })

    }

    // GOLDPASS TIMESTAMP
    //----------------------------------//
    if($('body').hasClass('goldpass_timestamp')) {

        // Use part of logic of products page

        // Custom from timestamp
        $('.removeCode').click(function() {

            // variables
            var code = $(this).data('code'),
                sid  = $(this).data('sid'),

                n = new Noty({
                type: 'confirm',
                layout: 'center',
                theme: 'nest',
                text: '<p>Voulez-vous retirer le code <code><strong>'+code+'</strong></code> de votre sélection ?</p>',
                buttons: [
                    Noty.button(cancelLocale[ajaxLang], 'btn btn-red btn-noty-left', function () {
                        // annuler
                        n.close();
                    }),
                    Noty.button(validationLocale[ajaxLang], 'btn btn-success btn-noty-right', function () {
                        // set code to unused
                        $.ajax({
                            type: 'POST',
                            url: ajaxLang + '/ajax',
                            data: {
                                code: code,
                                function: 'setGoldpassCodeUnused'
                            },
                            dataType: "json",
                            cache: false,
                        }).done(function (response) {
                            // delete block
                            $('#timestamp_'+sid).fadeOut(100).remove();
                            if(response.stillCodes=='no') {
                                $('#stillCodes').removeClass('hidden');
                                $('.addGoldpassToBasket').remove();
                            }
                            n.close();
                        });
                    })
                ],
                closeWith:['button']
            });
            n.show();

        })

        // Select main product to timestamp
        $('.select_main_product').on('change',function() {

            var show    = $(this,'option:selected').val(),
                sid     = $(this).data('sid');

            // hide all products
            $('.product_'+sid).addClass('hidden');
            $('.selection_'+sid).addClass('hidden');

            // show product to timestamp…
            $('#'+show+'_text').removeClass('hidden');
            $('.'+show+'_form').removeClass('hidden');
            // …& trigger shown product

            $('.'+show+'_form .subproduct').trigger('change');

        })

        $('select.subproduct').on('change',function() {
            validateGoldpassSelection();
        })


    };










    // ANIMATIONS' LIST
    //----------------------------------//
    if($('body').hasClass('visits')) {

        var maxEnd = $('.dateRangeEnd').data('max');

        $('.dateRangeStart').datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: 0,
            maxDate: '+'+maxEnd+'d',
            onSelect: function(date) {
                var ddmmyy  = date.split('/'),
                    dd      = ddmmyy[0],
                    mm      = ddmmyy[1],
                    yy      = ddmmyy[2],
                    jsDate  = yy + '-' + mm + '-' + dd;
                var endDate = new Date(jsDate);
                $('.dateRangeEnd').datepicker('option','minDate',endDate);
                setTimeout(function() {
                   $('.dateRangeEnd').datepicker('show');
                    filterAnimations();
                }, 100);
            }
        });
        $('.dateRangeEnd').datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: 0,
            maxDate: '+'+maxEnd+'d'
        });

        function filterAnimations() {

            // Filter Date
            var dateStart   = toTimestamp($('.dateRangeStart').val()),
                dateEnd     = toTimestamp($('.dateRangeEnd').val());

            // Filter Type
            var filter = '';
            $('.filter').each(function() {
                if($(this).hasClass('active')) {
                    filter = $(this).data('filter');
                }
            })

            // Hide / Show animation
            $('#animations > .animation').each(function() {
                if($(this).data('filter').includes(filter) &&
                   (dateStart<=$(this).data('end') && dateEnd>=$(this).data('start'))) {
                    $(this).removeClass('hidden');
                } else {
                    $(this).addClass('hidden');
                }
            })
        }

        // Filtering types
        $('.filter').click(function() {
            $('.filter').removeClass('active');
            $(this).addClass('active');
            filterAnimations();
        })

        // Filtering dates
        $('.dateRangeStart,.dateRangeEnd').change(function() {

            // Get vars
            var dStart   = toTimestamp($('.dateRangeStart').val()),
                dEnd     = toTimestamp($('.dateRangeEnd').val());

            // Process filtering
            if(dEnd>0 && dStart<=dEnd) {
                filterAnimations();
                console.log('filter');
            }

        })



    }

















    // CHECKOUT
    //----------------------------------//
    if($('body').hasClass('checkout')) {

        // update product quantity in basket
        //addProductToCheckout();

        // Remove product from basket
        /*$('.remove_product').click(function(e) {

            // variables
            var productCode = $(this).attr('data-remove'),
                productName = $(this).attr('data-productname'),
                section     = $(this).data('section'),
                mappingId   = $(this).data('mappingid');

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    productCode: productCode,
                    section: section,
                    mappingId: mappingId,
                    action: 'remove',
                    function: 'removeProductFromBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    $('.removedProduct').text(productName);
                    $('#productRemoved').removeClass('hidden');
                    window.location.reload();
                } else {
                    alert('Error');
                }
            });

        }) */

        // Remove product from basket
        $('.remove_product_single').click(function(e) {

            // variables
            var productCode = $(this).data('productcode'),
                eventId     = $(this).data('eventid'),
                productName = $(this).attr('data-productname');

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    productCode: productCode,
                    eventId: eventId,
                    function: 'removeProductSingleFromBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    $('.removedProduct').html(productName);
                    $('#productRemoved').removeClass('hidden');
                    // Wait 1 sec to reload page
                    setTimeout(function(){
                        window.location.reload();
                    }, 1500);
                } else {
                    alert('Error');
                }
            });

        })

        // Remove product from basket
        $('.remove_product_multiple').click(function(e) {

            // variables
            var productCode     = $(this).data('productcode'),
                productId       = $(this).data('productid'),
                section         = $(this).data('section'),
                productName     = $(this).attr('data-productname');

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    productCode: productCode,
                    productId: productId,
                    section: section,
                    function: 'removeProductMultipleFromBasket'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                if(response.status=='success') {
                    $('.removedProduct').html(productName);
                    $('#productRemoved').removeClass('hidden');
                    // Wait 1 sec to reload page
                    setTimeout(function(){
                        window.location.reload();
                    }, 1500);
                } else {
                    alert('Error while removing product');
                }
            });

        })

        // Validate promo code
        $('.validate_promocode').click(function(e) {

            // variables
            var promoCode = $('#promocode').val();

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    promoCode: promoCode,
                    function: 'validatePromoCode'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                $('#promocode_status').html('<br/>'+response.message);
                // Wait 1 sec to reload page
                setTimeout(function(){
                    window.location.reload();
                }, 2000);

            });

        })

    }

    // DETAILS
    //----------------------------------//
    if($('body').hasClass('details')) {

        // ZIP CODES
        $('#country').on('change', function() {

            var country_id = $(this).val();

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    country_id: country_id,
                    function: 'getZipCodes'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {

                $('#zip > .relative').html(response.field);
                $('#zip > .relative > #areas').select2();
            });

        });

        // Remove product from basket
        $('#formDetails').submit(function(e) {

            // do not submit
            e.preventDefault();

            var form = $(this).serializeArray();

            $('.validateDetails').prop('disabled',true);

            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    form: form,
                    function: 'validateDetails'
                },
                dataType: "json",
                cache: false,
            }).done(function (response) {
                // remove class has_error
                $('div[class*="error_"]').removeClass('has_error').find('.error').text('');
                // Add error label to empty fields
                if(response.status=='error') {
                    // Add class to show error in form
                    $.each(JSON.parse(response.highlights), function(field, errorText) {
                        $('.error_'+field).addClass('has_error');
                        $('.error_'+field).find('.error').html('<i class="fal fa-exclamation-triangle"></i> ' + errorText);
                    });
                    $('.validateDetails').prop('disabled',false);
                } else if(response.status=='success') {
                    // submit
                    $('#formDetails').unbind('submit').submit();
                }

            });

        })

    }


    // PAYMENT
    //----------------------------------//
    if($('body').hasClass('payment')) {

        $('#viva_com').click(function(e) {

            // SUbmit the form but only after the ajax call is completed
            $.ajax({
                type: 'POST',
                url: ajaxLang + '/ajax',
                data: {
                    function: 'increaseCountdownPayment'
                },
                dataType: "json",
                cache: false,
                complete: function() {
                    //window.location.href = viva_href;
                }
            });

        });

    }


    // Basket fixed bottom
    basketHeight();

    // SWITCHER LANG MOBILE
    if ($(window).width() < 768 ) {
        $('.icon_lang').click(function () {
            $(this).toggleClass('open');
        });
    }

    // Billetterie card exapand mobile
    if ($(window).width() < 768 ) {
        $('.card h2').click(function () {
            $(this).toggleClass('open');
        });
    }

    // input label up if not empty
    $('input').change(function(){
        if( $.trim($(this).val()).length > 0 ) {
            $(this).siblings('label').addClass('go_up');
        } else {
            $(this).siblings('label').removeClass('go_up');
        };
    });

    // input time
    $('input[type=time]').change(function(){
        if( $.trim($(this).val()).length > 0 ) {
            $(this).siblings('label').addClass('go_up');
            $(this).css('color','#64c2d0');
        } else {
            $(this).siblings('label').removeClass('go_up');
            $(this).css('color','transparent');
        };
    });

    // GLOBAL DATEPICKER
    //----------------------------------//
    $( function() {
        $( "#datepicker" ).datepicker();
        $( "#datepicker2" ).datepicker();
    });

});

$(window).resize(function() {
    // Basket fixed bottom
    basketHeight();
});
